import { globalConstants, USER_CONSTANTS } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  loginData: {},
  profileData: {},
  data: [],
  formData: {},
  permissions: [],
  notifications: [],
  notificationFormData: {},
  locations: []
};
//Manipulating the state of admin portal based on actions and returning the state
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_CONSTANTS.LOGIN + SUCCESS:
      return { ...state, loginData: action.data };
    case USER_CONSTANTS.PROFILE_DATA + SUCCESS:
      return { ...state, profileData: action.data };
    case USER_CONSTANTS.GET_USERS + SUCCESS:
      return { ...state, data: action.data };
    case USER_CONSTANTS.GET_USER_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    case USER_CONSTANTS.GET_PERMISSIONS + SUCCESS:
      return { ...state, permissions: action.data };
    case USER_CONSTANTS.GET_NOTIFICATIONS + SUCCESS:
      return { ...state, notifications: action.data };
    case USER_CONSTANTS.GET_NOTIFICATIONS_BY_ID + SUCCESS:
      return { ...state, notificationFormData: action.data };
    case USER_CONSTANTS.GET_LOCATIONS + SUCCESS:
      return { ...state, locations: action.data };
    default:
      return state;
  }
};
